export const SLIDER_DEFAULT = 'SLIDER_DEFAULT';
export const SLIDER_CUSTOM_NAV = 'SLIDER_CUSTOM_NAV';
